module.exports = __webpack_public_path__ + "static/media/opticalFiber.1153cab8.jpg";